import { useI18n } from "@/lib/i18n";

const TONES = {
  green: "bg-[#16A34A]/10 text-[#15803D]", red: "bg-[#DC2626]/10 text-[#B91C1C]", yellow: "bg-amber-100 text-amber-800",
  blue: "bg-[#2563EB]/10 text-[#1D4ED8]", gray: "bg-[#F3F4F6] text-[#4B5563]",
};
const MAP = {
  confirmed: "green", delivered: "green", completed: "green", refunded: "blue", paid: "green", active: "green", placed: "green", supplier_ordered: "green",
  processing: "blue", shipped: "blue", in_transit: "blue", ready_for_fulfillment: "blue", payment_confirmed: "blue", fulfilling: "blue", approved: "green",
  pending: "yellow", under_review: "yellow", info_required: "yellow", verification_required: "yellow", awaiting_item: "yellow", item_received: "blue",
  awaiting_refund: "yellow", refund_pending: "yellow", partially_refunded: "blue", requires_review: "red", failed: "red", rejected: "red",
  cancelled: "gray", closed: "gray", draft: "gray", archived: "gray", expired: "gray", revoked: "gray", under_review_payment: "red",
};

export default function StatusBadge({ status, group = "status", testid }) {
  const { t } = useI18n();
  return <span data-testid={testid} className={`chip ${TONES[MAP[status] || "gray"]}`}>{t(`${group}.${status}`)}</span>;
}

export const Tone = ({ tone, children }) => <span className={`chip ${TONES[tone]}`}>{children}</span>;
